import React from 'react';
import { User, Mail, Phone, Shield } from 'lucide-react';

const ContactStep = ({ formData, updateField }) => (
    <div className="space-y-5 animate-in fade-in slide-in-from-right-4 duration-300">
        <div className="text-center mb-2">
            <p className="text-sm text-gray-500">Almost there! We need your details to connect you with tutors.</p>
        </div>

        <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
                <User className="h-4 w-4 inline mr-1.5" />Full Name
            </label>
            <input
                type="text"
                value={formData.full_name}
                onChange={(e) => updateField('full_name', e.target.value)}
                placeholder="Enter your full name"
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm focus:border-[#041f96] focus:outline-none transition-colors"
            />
        </div>

        <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Mail className="h-4 w-4 inline mr-1.5" />Email Address
            </label>
            <input
                type="email"
                value={formData.email}
                onChange={(e) => updateField('email', e.target.value)}
                placeholder="your.email@example.com"
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm focus:border-[#041f96] focus:outline-none transition-colors"
            />
        </div>

        <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
                <Phone className="h-4 w-4 inline mr-1.5" />Phone Number
            </label>
            <div className="flex">
                <span className="inline-flex items-center px-4 py-3 border-2 border-r-0 border-gray-200 rounded-l-xl bg-gray-50 text-sm text-gray-600 font-medium">
                    +91
                </span>
                <input
                    type="tel"
                    value={formData.phone}
                    onChange={(e) => updateField('phone', e.target.value.replace(/\D/g, '').slice(0, 10))}
                    placeholder="10-digit mobile number"
                    maxLength={10}
                    className="flex-1 px-4 py-3 border-2 border-gray-200 rounded-r-xl text-sm focus:border-[#041f96] focus:outline-none transition-colors"
                />
            </div>
        </div>

        <div className="bg-blue-50 border border-blue-100 rounded-xl p-3 mt-2">
            <p className="text-xs text-blue-700 flex items-start gap-2">
                <Shield className="h-4 w-4 flex-shrink-0 mt-0.5" />
                We'll verify your phone number via OTP in the next step. Your information is secure and won't be shared without consent.
            </p>
        </div>
    </div>
);

export default ContactStep;
